import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Box, CssBaseline } from "@mui/material";
import { styled } from "@mui/material/styles";
import AlertSnackbar from "../AlertSnackbar";
import { useLocation } from "react-router-dom";

const drawerWidth = 240;

export default function Content({ children }) {
  const location = useLocation();
  const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
    ({ theme, open }) => ({
      flexGrow: 1,
      marginTop: location.pathname === "/opd" ? 0 : 60,
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      [theme.breakpoints.up("md")]: {
        padding: theme.spacing(
          location.pathname === "/" || location.pathname === "/opd/login"
            ? 0
            : 3
        ),
      },
      [theme.breakpoints.down("md")]: {
        padding: theme.spacing(1),
      },
      marginLeft: `-${drawerWidth}px`,
      ...(open && {
        transition: theme.transitions.create("margin", {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen,
        }),
        [theme.breakpoints.down("md")]: {
          marginLeft: `-${drawerWidth}px`,
          padding: theme.spacing(1),
        },
        [theme.breakpoints.up("md")]: {
          marginLeft: 0,
          padding: theme.spacing(3),
        },
      }),
    })
  );
  const [open, setOpen] = React.useState(false);
  const handleDrawerOpen = () => {
    setOpen(!open);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <>
      {/* <Box sx={{ display: "flex" }}> */}
      <CssBaseline />
      <Header
        open={open}
        handleDrawerOpen={handleDrawerOpen}
        handleDrawerClose={handleDrawerClose}
      />
      {/* <Main open={open}>{children}</Main> */}
      <Box
        sx={{
          p:
            location.pathname === "/" || location.pathname === "/opd/login"
              ? 0
              : 2,
          mt: location.pathname === "/" || location.pathname === "/opd" ? 0 : 8,
        }}
      >
        {children}
      </Box>
      {/* </Box> */}
      <AlertSnackbar />
      <Footer />
    </>
  );
}
